import { media, style } from "typestyle";
import { colors, queries } from "../../styles/styles";

export const purchaseActions = style(
  {
    display: "none",
    $nest: {
      "&>a, &>div": {
        display: "none"
      }
    }
  },
  media(queries.medium),
  {
    display: "flex",
    justifyContent: "flex-end",
    $nest: {
      "&>a, &>div": {
        display: "block",
        float: "left",
        marginLeft: ".5rem"
      }
    }
  }
);

export const revoked = style({
  color: colors.red_00,
  fontWeight: 600,
  textTransform: "uppercase"
});

export const arrow = style(
  {
    display: "block"
  },
  media(queries.medium, {
    display: "none"
  })
);
